import * as z from "zod";

const validationSchema = z.object({
  companyId: z.number(),
  name: z.string().min(1, { message: "validation:deviationNameRequired" }),
  price: z.number().min(0, { message: "validation:priceRequired" }),
  priceUnit: z.string().min(0, { message: "validation:paymentFrequencyRequired" }),
  currency: z.string().min(1, { message: "validation:currencyRequired" }),
  description: z
    .string()
    .min(1, { message: "validation:descriptionRequired" })
    .max(200, { message: "validation:descriptionMaxLength" }),
});

export const ContractDeviationValidationSchema = validationSchema;
export type ContractDeviationFormInput = z.infer<typeof ContractDeviationValidationSchema>;
